import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Container, Col } from 'react-bootstrap';
import {
  fetchOutrightsAllEvents,
  selectFilteredEvents,
  selectAvailableSports,
  selectOutrightsLoading,
  selectOutrightsError,
  selectSelectedSportId,
  setSelectedSportId,
  clearOutrightsError
} from 'stores/outrights';
import Loading from 'components/general/loading.js';
import Desktop from 'components/breakpoints/Desktop.js';
import Default from 'components/breakpoints/Default.js';
import LeftSidebar from 'views/home/_desktop/left_sidebar';
import RightSidebar from 'views/home/_desktop/right_Sidebar';
import TournamentCard from './components/TournamentCard';
import SportChips from './components/SportChips';

function Outrights() {
  const { t } = useTranslation('translations', { useSuspense: false });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const events = useSelector(selectFilteredEvents);
  const sports = useSelector(selectAvailableSports);
  const loading = useSelector(selectOutrightsLoading);
  const error = useSelector(selectOutrightsError);
  const selectedSportId = useSelector(selectSelectedSportId);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchOutrightsAllEvents());
  }, [dispatch]);

  const onRetry = () => {
    dispatch(clearOutrightsError());
    dispatch(fetchOutrightsAllEvents());
  };

  const mainContent = (
    <>
      <SportChips
        sports={sports}
        selectedSportId={selectedSportId}
        onSelect={(id) => dispatch(setSelectedSportId(id))}
        onBack={() => navigate(-1)}
      />

      <div className="px-1 py-3 outrights-content">
        {loading && <Loading message={t('outrights.loading')} />}

        {!loading && error && (
          <div
            className="rounded p-3 text-center"
            style={{
              background: 'var(--bs-body-bg)',
              border: '1px solid var(--bs-border-color)'
            }}
          >
            <div className="mb-2" style={{ color: 'var(--bs-body-color)' }}>
              {error}
            </div>
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={onRetry}
            >
              {t('outrights.retry')}
            </button>
          </div>
        )}

        {!loading && !error && events.length === 0 && (
          <div
            className="text-center py-4"
            style={{ opacity: 0.65, color: 'var(--bs-body-color)' }}
          >
            {t('outrights.noEvents')}
          </div>
        )}

        {!loading && !error &&
          events.map((event) => (
            <TournamentCard key={event.se.id} event={event} />
          ))}
      </div>
    </>
  );

  return (
    <>
      <Desktop>
        <div className="container-fluid py-2">
          <div className="row flex-nowrap">
            <Col xs={2} className="filter-sidebar">
              <LeftSidebar />
            </Col>
            <Col xs={7}>{mainContent}</Col>
            <Col xs={3}>
              <RightSidebar />
            </Col>
          </div>
        </div>
      </Desktop>
      <Default>
        <Container fluid className="g-0">
          {mainContent}
        </Container>
      </Default>
    </>
  );
}

export default Outrights;
